import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS, FOUNDER } from "../../data/content";
import Reveal from "./Reveal";

export default function FounderSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="founder"
      ref={ref}
      data-testid="founder-section"
      className="relative bg-[#050B14] py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          {/* Image / portrait substitute */}
          <div className="col-span-12 lg:col-span-6 order-2 lg:order-1">
            <div className="relative aspect-[4/5] overflow-hidden">
              <motion.img
                style={{ y }}
                src={ASSETS.yacht.sunsetProfile}
                alt="Sunreef 80 Eco at sunset — Francis Lapp's flagship MARIE-JOSEPH"
                loading="lazy"
                className="absolute inset-0 w-full h-[115%] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-white/80">
                <div className="overline">Founder · Sunreef Yachts</div>
                <div className="overline text-[10px]">01 / 09</div>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="col-span-12 lg:col-span-6 order-1 lg:order-2 lg:pl-12">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{FOUNDER.overline}</span>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <h2
                data-testid="founder-headline"
                className="font-serif-display text-white text-[clamp(2.25rem,5vw,4.5rem)] leading-[1.05] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {FOUNDER.title}
              </h2>
            </Reveal>

            <Reveal delay={0.25}>
              <p className="mt-10 text-[#D4C9A8] text-base md:text-lg font-light leading-relaxed max-w-xl">
                {FOUNDER.body}
              </p>
            </Reveal>

            <Reveal delay={0.4}>
              <figure className="mt-14 border-l border-[#E5D3B3]/40 pl-8 max-w-xl">
                <blockquote
                  data-testid="founder-quote"
                  className="font-serif-display italic text-white text-xl md:text-2xl leading-relaxed font-light"
                >
                  &ldquo;{FOUNDER.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6 overline text-[11px] text-white/60">
                  — {FOUNDER.attribution}
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
